import { slideFragment } from '@/modules/slides-core/data/slide-fragment'
import gql from 'graphql-tag'

export const SLIDES_ATIVOS = gql`
  query SlidesAtivosQuery {
    slidesAtivos {
      ...SlideFragment
    }
  }
  ${slideFragment}
`
